import type { QueryClient } from "@tanstack/react-query"
import { isHandledError } from "../../../../hooks"
import { HTTP_STEP_UP_REQUIRED } from "../const"

export const resendBlockedQueries = (client: QueryClient) =>
  client.refetchQueries({
    predicate: (query) =>
      isHandledError(query.state.error) &&
      query.state.error.statusCode === HTTP_STEP_UP_REQUIRED,
  })
